class CarouselSettings {

    constructor() {
        this.onMutate()
    }

    onMutate() {
        const config = { attributes: true, childList: true, subtree: true };
                    
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === 'childList') {
                    let $elementedAdded = mutation.addedNodes[0]
                    if($elementedAdded.classList.contains('carousel-col')) {
                        this.getCarousel($elementedAdded)
                    }
                }
            }
        }

        const observer = new MutationObserver(callback);
        observer.observe(document.querySelector('.index'), config);
    }


    getCarousel($el) {

        let $section  = $el
        
        let $carousel_title = $section.querySelectorAll(".carousel-col__each-title");
        let $carousel = $section.querySelectorAll("li.carousel-col__each-carou");
        let current_index = 0;

        $carousel_title[current_index].classList.add("caroul-title-active");
        $carousel[current_index].classList.add("caroul-el-active");

        function titleClicked($el) {
            $carousel_title.forEach((el) => el.classList.remove("caroul-title-active"));
            $carousel.forEach((el) => el.classList.remove("caroul-el-active"));
            $carousel_title[current_index].classList.add("caroul-title-active");
            $carousel[current_index].classList.add("caroul-el-active");
        }

        $carousel_title.forEach((el) => {
            el.addEventListener("click", () => {
                let thisIndex = [].indexOf.call($carousel_title, el);
                current_index = thisIndex;
                titleClicked(el);
            });
        });


    }

}


if(window.location.href.includes('/?')) {
    new CarouselSettings()
}


